// 21 Tech Themes — each has accent colors, orb colors, and a CSS pattern style
export const THEMES = [
  // ── LUX AI OS (الافتراضي — أسود فاخر + زمردي) ────────────────────────
  {
    id: 'lux',
    name: 'AI لوكس',
    category: 'واقعي فاخر ✨',
    accent: '#16D67A',
    accentRgb: '22,214,122',
    grad1: '#12B368',
    grad2: '#065F41',
    orb1: 'rgba(22,214,122,0.10)',
    orb2: 'rgba(22,214,122,0.06)',
    orb3: 'rgba(40,245,167,0.05)',
    pattern: 'lux',
    gridColor: 'rgba(22,214,122,0.03)',
    soft: true,
    lux: true,
  },

  // ── REALISTIC AURORA (soft & smooth) ──────────────────────────────────
  {
    id: 'cyber-aurora',
    name: 'سايبر أورورا',
    category: 'واقعي فاخر ✨',
    accent: '#67E8F9',
    accentRgb: '103,232,249',
    grad1: '#06B6D4',
    grad2: '#1E3A8A',
    orb1: 'rgba(103,232,249,0.22)',
    orb2: 'rgba(99,102,241,0.18)',
    orb3: 'rgba(45,212,191,0.12)',
    pattern: 'aurora',
    gridColor: 'rgba(103,232,249,0.05)',
    soft: true,
  },

  // ── CIRCUIT BOARD PATTERN ─────────────────────────────────────────────
  {
    id: 'cyber-cyan',
    name: 'سايبر سيان',
    category: 'دوائر إلكترونية',
    accent: '#00E5FF',
    accentRgb: '0,229,255',
    grad1: '#00B8D4',
    grad2: '#0091EA',
    orb1: 'rgba(0,229,255,0.18)',
    orb2: 'rgba(41,121,255,0.14)',
    orb3: 'rgba(0,230,118,0.08)',
    pattern: 'circuit',
    gridColor: 'rgba(0,229,255,0.05)',
  },
  {
    id: 'purple-ai',
    name: 'ذكاء بنفسجي',
    category: 'دوائر إلكترونية',
    accent: '#CE93D8',
    accentRgb: '206,147,216',
    grad1: '#AB47BC',
    grad2: '#7B1FA2',
    orb1: 'rgba(206,147,216,0.18)',
    orb2: 'rgba(123,31,162,0.14)',
    orb3: 'rgba(225,190,231,0.07)',
    pattern: 'circuit',
    gridColor: 'rgba(206,147,216,0.05)',
  },
  {
    id: 'matrix-green',
    name: 'ماتريكس',
    category: 'دوائر إلكترونية',
    accent: '#69F0AE',
    accentRgb: '105,240,174',
    grad1: '#00C853',
    grad2: '#1B5E20',
    orb1: 'rgba(105,240,174,0.18)',
    orb2: 'rgba(0,200,83,0.14)',
    orb3: 'rgba(0,230,118,0.07)',
    pattern: 'circuit',
    gridColor: 'rgba(105,240,174,0.05)',
  },
  {
    id: 'crimson-tech',
    name: 'أحمر نيون',
    category: 'دوائر إلكترونية',
    accent: '#FF5252',
    accentRgb: '255,82,82',
    grad1: '#E53935',
    grad2: '#B71C1C',
    orb1: 'rgba(255,82,82,0.18)',
    orb2: 'rgba(229,57,53,0.14)',
    orb3: 'rgba(255,138,128,0.07)',
    pattern: 'circuit',
    gridColor: 'rgba(255,82,82,0.05)',
  },

  // ── NEURAL NETWORK PATTERN ────────────────────────────────────────────
  {
    id: 'ocean-blue',
    name: 'المحيط العميق',
    category: 'شبكة عصبية',
    accent: '#40C4FF',
    accentRgb: '64,196,255',
    grad1: '#0288D1',
    grad2: '#01579B',
    orb1: 'rgba(64,196,255,0.18)',
    orb2: 'rgba(2,136,209,0.14)',
    orb3: 'rgba(129,212,250,0.07)',
    pattern: 'neural',
    gridColor: 'rgba(64,196,255,0.05)',
  },
  {
    id: 'golden-neural',
    name: 'شبكة ذهبية',
    category: 'شبكة عصبية',
    accent: '#FFD740',
    accentRgb: '255,215,64',
    grad1: '#FFA000',
    grad2: '#FF6F00',
    orb1: 'rgba(255,215,64,0.18)',
    orb2: 'rgba(255,160,0,0.14)',
    orb3: 'rgba(255,213,79,0.07)',
    pattern: 'neural',
    gridColor: 'rgba(255,215,64,0.05)',
  },
  {
    id: 'rose-quartz',
    name: 'كوارتز وردي',
    category: 'شبكة عصبية',
    accent: '#F48FB1',
    accentRgb: '244,143,177',
    grad1: '#E91E63',
    grad2: '#880E4F',
    orb1: 'rgba(244,143,177,0.18)',
    orb2: 'rgba(233,30,99,0.14)',
    orb3: 'rgba(255,128,171,0.07)',
    pattern: 'neural',
    gridColor: 'rgba(244,143,177,0.05)',
  },
  {
    id: 'teal-horizon',
    name: 'أفق فيروزي',
    category: 'شبكة عصبية',
    accent: '#64FFDA',
    accentRgb: '100,255,218',
    grad1: '#00BFA5',
    grad2: '#00695C',
    orb1: 'rgba(100,255,218,0.18)',
    orb2: 'rgba(0,191,165,0.14)',
    orb3: 'rgba(128,203,196,0.07)',
    pattern: 'neural',
    gridColor: 'rgba(100,255,218,0.05)',
  },

  // ── HEXAGONAL PATTERN ─────────────────────────────────────────────────
  {
    id: 'solar-flare',
    name: 'لهب شمسي',
    category: 'شبكة سداسية',
    accent: '#FF9100',
    accentRgb: '255,145,0',
    grad1: '#FF6D00',
    grad2: '#DD2C00',
    orb1: 'rgba(255,145,0,0.18)',
    orb2: 'rgba(221,44,0,0.14)',
    orb3: 'rgba(255,171,64,0.07)',
    pattern: 'hex',
    gridColor: 'rgba(255,145,0,0.05)',
  },
  {
    id: 'arctic-ice',
    name: 'قطبي ثلجي',
    category: 'شبكة سداسية',
    accent: '#B3E5FC',
    accentRgb: '179,229,252',
    grad1: '#29B6F6',
    grad2: '#0277BD',
    orb1: 'rgba(179,229,252,0.18)',
    orb2: 'rgba(41,182,246,0.14)',
    orb3: 'rgba(225,245,254,0.07)',
    pattern: 'hex',
    gridColor: 'rgba(179,229,252,0.05)',
  },
  {
    id: 'emerald',
    name: 'زمرد',
    category: 'شبكة سداسية',
    accent: '#76FF03',
    accentRgb: '118,255,3',
    grad1: '#64DD17',
    grad2: '#1B5E20',
    orb1: 'rgba(118,255,3,0.14)',
    orb2: 'rgba(100,221,23,0.12)',
    orb3: 'rgba(178,255,89,0.07)',
    pattern: 'hex',
    gridColor: 'rgba(118,255,3,0.04)',
  },
  {
    id: 'violet-dreams',
    name: 'أحلام بنفسجية',
    category: 'شبكة سداسية',
    accent: '#EA80FC',
    accentRgb: '234,128,252',
    grad1: '#E040FB',
    grad2: '#6A1B9A',
    orb1: 'rgba(234,128,252,0.18)',
    orb2: 'rgba(224,64,251,0.14)',
    orb3: 'rgba(225,190,231,0.07)',
    pattern: 'hex',
    gridColor: 'rgba(234,128,252,0.05)',
  },

  // ── MATRIX / DATA STREAMS ─────────────────────────────────────────────
  {
    id: 'midnight',
    name: 'منتصف الليل',
    category: 'تدفق البيانات',
    accent: '#7986CB',
    accentRgb: '121,134,203',
    grad1: '#3949AB',
    grad2: '#1A237E',
    orb1: 'rgba(121,134,203,0.18)',
    orb2: 'rgba(57,73,171,0.14)',
    orb3: 'rgba(159,168,218,0.07)',
    pattern: 'data',
    gridColor: 'rgba(121,134,203,0.05)',
  },
  {
    id: 'copper',
    name: 'نحاسي تقني',
    category: 'تدفق البيانات',
    accent: '#FFAB40',
    accentRgb: '255,171,64',
    grad1: '#FB8C00',
    grad2: '#E65100',
    orb1: 'rgba(255,171,64,0.18)',
    orb2: 'rgba(251,140,0,0.14)',
    orb3: 'rgba(255,204,128,0.07)',
    pattern: 'data',
    gridColor: 'rgba(255,171,64,0.05)',
  },
  {
    id: 'electric-blue',
    name: 'أزرق كهربائي',
    category: 'تدفق البيانات',
    accent: '#448AFF',
    accentRgb: '68,138,255',
    grad1: '#2979FF',
    grad2: '#1565C0',
    orb1: 'rgba(68,138,255,0.18)',
    orb2: 'rgba(41,121,255,0.14)',
    orb3: 'rgba(130,177,255,0.07)',
    pattern: 'data',
    gridColor: 'rgba(68,138,255,0.05)',
  },
  {
    id: 'jade',
    name: 'يشم فاخر',
    category: 'تدفق البيانات',
    accent: '#A7FFEB',
    accentRgb: '167,255,235',
    grad1: '#1DE9B6',
    grad2: '#00695C',
    orb1: 'rgba(167,255,235,0.18)',
    orb2: 'rgba(29,233,182,0.14)',
    orb3: 'rgba(128,203,196,0.07)',
    pattern: 'data',
    gridColor: 'rgba(167,255,235,0.05)',
  },

  // ── WAVE / SIGNAL ─────────────────────────────────────────────────────
  {
    id: 'cosmic',
    name: 'كوني غامض',
    category: 'موجات رقمية',
    accent: '#B39DDB',
    accentRgb: '179,157,219',
    grad1: '#7E57C2',
    grad2: '#4527A0',
    orb1: 'rgba(179,157,219,0.18)',
    orb2: 'rgba(126,87,194,0.14)',
    orb3: 'rgba(209,196,233,0.07)',
    pattern: 'wave',
    gridColor: 'rgba(179,157,219,0.05)',
  },
  {
    id: 'neon-pink',
    name: 'وردي نيون',
    category: 'موجات رقمية',
    accent: '#FF4081',
    accentRgb: '255,64,129',
    grad1: '#F50057',
    grad2: '#880E4F',
    orb1: 'rgba(255,64,129,0.18)',
    orb2: 'rgba(245,0,87,0.14)',
    orb3: 'rgba(255,128,171,0.07)',
    pattern: 'wave',
    gridColor: 'rgba(255,64,129,0.05)',
  },
  {
    id: 'desert-sun',
    name: 'شمس الصحراء',
    category: 'موجات رقمية',
    accent: '#FFCC02',
    accentRgb: '255,204,2',
    grad1: '#FFB300',
    grad2: '#E65100',
    orb1: 'rgba(255,204,2,0.18)',
    orb2: 'rgba(255,179,0,0.14)',
    orb3: 'rgba(255,236,179,0.07)',
    pattern: 'wave',
    gridColor: 'rgba(255,204,2,0.05)',
  },
  {
    id: 'toxic-green',
    name: 'أخضر سام',
    category: 'موجات رقمية',
    accent: '#CCFF90',
    accentRgb: '204,255,144',
    grad1: '#76FF03',
    grad2: '#33691E',
    orb1: 'rgba(204,255,144,0.14)',
    orb2: 'rgba(118,255,3,0.12)',
    orb3: 'rgba(241,248,233,0.07)',
    pattern: 'wave',
    gridColor: 'rgba(204,255,144,0.04)',
  },
];

export const DEFAULT_THEME_ID = 'lux';

export const getThemeById = (id) =>
  THEMES.find(t => t.id === id) || THEMES[0];
